import type { AllocationForm } from "./AddAllocationForm";

interface LinkCardProps {
  formValues: AllocationForm;
  account: "gas" | "electricity" | "bank" | undefined;
  showBpayWarning?: boolean;
}

export default function LinkCard({
  formValues,
  account,
  showBpayWarning = false,
}: LinkCardProps) {
  const renderDetailRow = (label: string, value: string | number | undefined) => (
    <>
      <p className="text-sm text-brand-neutral-500">{label}</p>
      <p className="font-medium break-words">{value ?? "-"}</p>
    </>
  );

  return (
    <div className="border rounded-lg p-6 bg-brand-neutral-700">
      <div className="space-y-4">
        <h3 className="text-md font-semibold mb-2 capitalize">
          {account} Link
        </h3>
        <div className="grid grid-cols-2 gap-4">
          {renderDetailRow("Account Nickname", formValues.nickname)}
          {renderDetailRow(
            "Panels",
            `${formValues.wattCapacity / 100} (${formValues.wattCapacity / 1000}kW)`
          )}

          {formValues.paymentType === "energyCompany" && (
            <>
              {renderDetailRow(
                "Energy Company",
                formValues.energyCompany?.name?.toLowerCase() === "other"
                  ? formValues.otherName
                  : formValues.energyCompany?.name
              )}

              <div className="border-t pt-4 mt-4 col-span-2">
                <h3 className="text-md font-semibold mb-2">BPAY Details</h3>
                <div className="grid grid-cols-2 gap-4">
                  {renderDetailRow("Biller Code", formValues.billerCode)}
                  {renderDetailRow(
                    "Customer Reference Number",
                    formValues.customerReferenceNumber
                  )}
                </div>
              </div>
            </>
          )}

          {formValues.paymentType === "bank" && (
            <>
              {renderDetailRow("Account Name", formValues.accountName)}
              {renderDetailRow("BSB", formValues.bsb)}
              {renderDetailRow("Account Number", formValues.accountNumber)}
            </>
          )}

          {formValues.paymentType === "paypal" && (
            <>{renderDetailRow("PayPal Email", formValues.paypalEmail)}</>
          )}
        </div>
      </div>

      {showBpayWarning && (
        <div className="mt-6 p-4 bg-brand-blue-300 rounded-lg">
          <p className="text-sm text-black">
            Please double-check that your BPAY details are correct. Incorrect
            details may delay your credits.
          </p>
        </div>
      )}
    </div>
  );
}
